import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiKeysService } from 'src/api/services';
import { ApiKey } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-api-keys',
  templateUrl: './api-keys.component.html',
  styleUrls: ['./api-keys.component.css']
})
export class ApiKeysComponent implements OnInit {

  keys : ApiKey[]
  newKey: ApiKey;
  minDate: string;
  maxDate: string;

  constructor(
    public service: ApiKeysService,
    public app: ApplicationConfigService,
    private toastr: ToastrService
    ) { 

    }

  ngOnInit(): void {    
    const now = new Date();    
    this.minDate = now.toISOString().slice(0, 16);
    now.setDate(now.getDate() + 365);
    this.maxDate = now.toISOString().slice(0, 16);

    this.service.ApiKeysGetAll().subscribe({
      next: r => { this.keys = r; },
      error: () => this.toastr.error('Failed to load API keys', 'Error')
    });
  }

  addNewKey(){
    this.newKey = {} as ApiKey;
  }

  saveNewKey(){
    this.service.ApiKeysPost(this.newKey).subscribe({
      next: r => {
        this.keys.push(r);
        this.newKey = null;
        this.toastr.success('API key created', 'Success');
      },
      error: () => this.toastr.error('Failed to create API key', 'Error')
    });
  }

  revokeKey(key: ApiKey){
    this.service.ApiKeysDelete(key.apiKeyId).subscribe({
      next: () => {
        this.service.ApiKeysGetAll().subscribe({
          next: r => {
            this.keys = r;
            this.toastr.success('API key revoked', 'Success');
          },
          error: () => this.toastr.error('Failed to refresh API keys', 'Error')
        });
      },
      error: () => this.toastr.error('Failed to revoke API key', 'Error')
    });
  }

  revealKey(key: ApiKey){
    this.service.ApiKeysRevealKey(key.apiKeyId).subscribe({
      next: r => {
        const index = this.keys.indexOf(key);
        if (index !== -1) {
          this.keys[index] = r;
        }
        this.toastr.success('API key revealed', 'Success');
      },
      error: () => this.toastr.error('Failed to reveal API key', 'Error')
    });
  }

  isExpired(key: ApiKey): boolean {
    if (!key.expiryDate) return false;
    return new Date(key.expiryDate) < new Date();
  }


}
